import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { AttributeFilter } from 'app/shared/ui/models/attribute-filter';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { BaryModalService } from '../../../../services/bary-modal.service';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';

@Component({
  selector: 'jhi-data-filter',
  templateUrl: './data-filter.component.html',
  styleUrls: ['./data-filter.component.scss'],
})
export class DataFilterComponent {
  private readonly baryModalService = inject(BaryModalService);

  @Input() options: AttributeFilter[] = [];
  @Input() filters = Object.create({});
  @Output() filtersChange = new EventEmitter<any>();

  modalRef?: NgbModalRef;

  protected readonly FAS = FaDirectiveEnum.FAS;

  showModal(): void {
    this.baryModalService
      .openFilters(this.options, this.filters)
      .action()
      .subscribe(event => {
        if (event.submit) {
          this.updateAndSaveFilters();
        }
      });
  }

  removeFilterAttribute(key: string): void {
    Object.keys(this.filters).forEach(filterProperty => {
      if (filterProperty.startsWith(key)) {
        delete this.filters[filterProperty];
      }
    });
  }

  removeFilter(filter: AttributeFilter): void {
    this.removeFilterAttribute(filter.attribute);
    this.updateAndSaveFilters();
  }

  updateAndSaveFilters(): void {
    this.options.forEach(option => {
      if (option.isChecked()) {
        Object.assign(this.filters, option.updateValue());
      } else {
        this.removeFilterAttribute(option.attribute);
      }
      option.tempValue = option.value;
      option.tempSecondValue = option.secondValue;
    });
    this.filtersChange.emit(this.filters);
    if (this.modalRef !== undefined) {
      this.modalRef.close();
    }
  }
}
